import type { Patient } from '@/models/patient';
import type { PatientSnapshot } from '@/services/api/transfer';

export function patientToSnapshot(p: Patient): PatientSnapshot {
  return {
    firstName: p.firstName,
    lastName: p.lastName,
    dob: p.dob,
    healthCard: p.healthCard,
    healthCardExp: p.healthCardExp,
    sex: p.sex,
    civ: p.civ,
    dx: p.dx,
    notes: p.notes,
  };
}
